
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organization]/[locale]/collabmap/[slug]/invitationError",
      function () {
        return require("private-next-pages/[organization]/[locale]/collabmap/[slug]/invitationError.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organization]/[locale]/collabmap/[slug]/invitationError"])
      });
    }
  